import { getCurrentInstance } from "vue"
import { getUrlBoolean } from "@/utils/UrlParam"

export const useDotsTrigger = ({
  trigger,
  start = "top bottom",
  end = "bottom bottom",
  to = {},
  debug = false,
}) => {
  const { $gsap, $ScrollTrigger } = useNuxtApp()
  const dots = useDots()

  const enter = () => {
    if (!pageHasEntered.value) return
    if (!trigger.value) return
    if (debug) console.log("useDotsTrigger.enter", trigger)
    dots.animateTo({
      to,
    })
  }

  const id = computed(() => {
    return getCurrentInstance()?.type.__name
  })

  const pageHasEntered = ref(false)
  usePageEnter(async () => {
    await nextTick()
    await delay(100)
    pageHasEntered.value = true
  })

  const route = useRoute()
  watch(
    () => route.path,
    () => {
      pageHasEntered.value = false
    }
  )

  const { init } = useScrollTrigger(() => {
    if (!trigger.value) return
    return new $ScrollTrigger({
      id: `Dots-${id.value}`,
      trigger: trigger.value,
      start,
      end,
      markers: getUrlBoolean("dots-trigger", debug),
      onEnter: () => {
        if (!pageHasEntered.value) return
        if (debug) console.log("onEnter", id, trigger.value, start, end)
        enter()
      },
      onEnterBack: () => {
        if (!pageHasEntered.value) return
        if (debug) console.log("onEnterBack", id, trigger.value, start, end)
        enter()
      },
      // markers: true,
    })
  }, true)

  watch(
    () => trigger.value,
    () => {
      if (trigger.value) {
        init()
      }
    }
  )

  onMounted(() => {
    if (trigger.value) init()
  })
}
